var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8036 2.39216C12.4179 2.39216 12.1071 2.74077 12.1071 3.17352V5.21707H11.4857V3.45H5.03571V5.21707H1.39286V0.781359C1.39286 0.348606 1.08214 0 0.696429 0C0.310714 0 0 0.348606 0 0.781359V8.58293H1.39286V6.99617H5.03571V8.00592H11.475V6.99617H12.0964V8.58293H13.4893V3.17352C13.5 2.74077 13.1893 2.39216 12.8036 2.39216Z",
    fill: "#505565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3999 4.50811L3.86776 4.68843C4.14633 4.72449 4.38205 4.49609 4.41419 4.19557C4.44633 3.88303 4.24276 3.61857 3.9749 3.5825L2.50705 3.40219C2.22848 3.36613 1.99276 3.59452 1.96062 3.89505C1.92848 4.19557 2.13205 4.47205 2.3999 4.50811Z",
    fill: "#505565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/Bed.798eeb47d356955e0b45e363ca73263b.svg";
export { ForwardRef as ReactComponent };